


const movePriceElem = () => {
  const priceElem = document.querySelector('.cpb-product-actions .cpb-product-full-price');
  const panelsContainer = document.querySelector('.cpb-panels-container');

  if (innerWidth > 999) {
    panelsContainer.prepend(priceElem);
  }
}

function prependUnderscroreToViewsProps() {
    if (!!window._cpb.settings === false) window._cpb.settings = {}
    window._cpb.settings.addToCartOverride = async data => {
        data.items.forEach(item => {
          const properties = item.properties;
          console.log(item);
          for (const prop in properties) {
            if (prop.toLowerCase().includes("view")) {
              properties["_" + prop] = properties[prop];
              delete properties[prop];
            };
          }; 
        })

        fetch("/cart/add.js", {
            "headers": {
                "content-type": "application/json;charset=UTF-8"
            },
            "body": JSON.stringify({
                items: data.items
            }),
            "method": "POST"
        }).then(() => {
            if(data.redirect) location.href = '/cart'
        })
    }
}

const apllySelectedShopifyVariantsAsSelectedChoices = () => {
  const peronalizeBtn = document.querySelector('.personalize-it--js');

  const peronalizeBtnClickHandler = () => {
    const switchersContainer = document.querySelector('.t4s-swatch');
    if (!switchersContainer || switchersContainer.childElementCount == 0) return
    const selectedOptions = Array.from(switchersContainer.children).map(swatchOptionElem => {
      const titleContainer = swatchOptionElem.querySelector('.t4s-swatch__title > span');
      const currentValue = titleContainer.querySelector('span[data-current-value]').textContent;
      return {
        title: titleContainer.textContent.replace(`: ${currentValue}`, ''),
        value: currentValue
      };
    });
    
    window.shopifyVariantsForCPB = selectedOptions;
    
    if (window.CPB?.getStore().getState().Product.panels.length > 0) {
      applySelectionsToBuilder();
    } else {
      document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
        applySelectionsToBuilder();
      })
    }
  }

  const isDefault = (optionId) => {
    const defaultOptions = CPB.getStore().getState().App.settings.defaultOptions;
    for (let p in defaultOptions) {
      for (let c in defaultOptions[p]) {
        if (defaultOptions[p][c] == optionId) return true;
        if (typeof defaultOptions[p][c] == 'object' && defaultOptions[p][c].includes(optionId)) return true;
      };
    };
    return false;
  }

  const applySelectionsToBuilder = async () => {
    let api = await CPB.FrontendApi();
    api = new api();
    const Product = CPB.getStore().getState().Product;
    const objectsForApi = [];
    
    window.shopifyVariantsForCPB?.forEach(selectedVariant => {
      let panel, category, option;
      Product.panels.find(p => {
        p.categories.find(c => {
          if (c.title == selectedVariant.title) {
            c.options.find(o => {
              if (o.option.data.label == selectedVariant.value) {
                panel = p;
                category = c;
                option = o;
                return true;
              }
            })
            return true;
          }
        });
        return false
      });
      if (panel && category && option && !isDefault(option.id)) {
        objectsForApi.push({
          panel,
          category,
          options: [option]
        });
      };
    });

    for (let object of objectsForApi) {
      await api.updateOptions(object);
    }
  }

  peronalizeBtn.addEventListener('click', peronalizeBtnClickHandler);

}

addEventListener("DOMContentLoaded", (event) => {
  apllySelectedShopifyVariantsAsSelectedChoices();
});

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
  movePriceElem();
  prependUnderscroreToViewsProps();
})


